import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { H2, Text } from '../../../elements/typography'
import { SemiBorderedBlock } from '../SemiBorderedBlock/SemiBorderedBlock'
import { Badge } from './Badge/Badge'
import { BulletList } from './BulletList/BulletList'

const Block = styled(SemiBorderedBlock).attrs((props) => ({
  minWidth: props.minWidth || 320,
}))`
  padding: ${(props) => props.theme.spacing.larger}px ${(props) => props.theme.spacing.smedium}px;
`

const Title = styled(H2)`
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
  margin-bottom: ${(props) => props.theme.spacing.medium}px;
`

const BillingNoteArea = styled(View)`
  justify-content: center;
  margin-bottom: ${(props) => props.theme.spacing.small}px;
`

const BenefitsArea = styled(View)`
  margin-top: auto;
  align-items: center;
  margin-bottom: ${(props) => props.theme.spacing.large}px;
`

const BillingNote = styled(Text)`
  text-align: center;
  color: ${(props) => props.theme.colors.grayDark};
  font-size: ${(props) => props.theme.fontSizes.xsmall}px;
`

const BillingNoteEmphasised = styled(BillingNote)`
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.medium + 2}px;
`

const ClosingPromo = styled(Text)`
  color: ${(props) => props.theme.colors.grayDark};
  font-size: ${(props) => props.theme.fontSizes.small}px;
  font-weight: ${(props) => props.theme.fontWeights.bold};
`

const AccentedPlus = styled(Text)`
  color: ${(props) => props.theme.colors.accent};
  font-size: ${(props) => props.theme.fontSizes.xxlarge}px;
  line-height: ${(props) => props.theme.fontSizes.xxlarge}px;
`

export const PlanPromoBlockV1 = ({ plan, selected, minWidth, children }) => {
  const { title, badge, benefits, benefitsMore, billingNoteEmphasised, billingNote, closingPromo } =
    plan.promoBlock.v1
  return (
    <Block selected={selected} minWidth={minWidth}>
      <Title>{title}</Title>

      {badge && <Badge color={badge.color}>{badge.text}</Badge>}

      <BillingNoteArea>
        <BillingNoteEmphasised>{billingNoteEmphasised}</BillingNoteEmphasised>
        <BillingNote>{billingNote || ' '}</BillingNote>
      </BillingNoteArea>

      <BenefitsArea>
        {benefits && <BulletList {...benefits} />}

        {benefitsMore && (
          <>
            <AccentedPlus>+</AccentedPlus>
            <BulletList {...benefitsMore} />
          </>
        )}
      </BenefitsArea>

      {children}

      <ClosingPromo>{closingPromo}</ClosingPromo>
    </Block>
  )
}

PlanPromoBlockV1.Block = Block
PlanPromoBlockV1.Title = Title
PlanPromoBlockV1.BulletList = BulletList
PlanPromoBlockV1.BillingNote = BillingNote
PlanPromoBlockV1.BillingNoteEmphasised = BillingNoteEmphasised

PlanPromoBlockV1.propTypes = {
  plan: PropTypes.object.isRequired,
  onPress: PropTypes.func,
  selected: PropTypes.bool,
}
